export const LOGIN_TOKEN_STORAGE_KEY = "loginToken";



// WEBPACK FOOTER //
// ./src/routes/Auth/constants.ts